<template>
  <v-container>
    <form id="formGMC" ref="formGmc" style="display:none;" method="post" 
        :action="gmcFormData.actionUrl">
        <input type="text" :value="gmcFormData.merchantCode" name="MERCHANTCODE" id="MERCHANTCODE">
        <input type="text" :value="gmcFormData.paymentCode" name="PAYMENTCODE" id="PAYMENTCODE">
        <input type="text" :value="gmcFormData.productDesc" name="PRODUCTDESC" id="PRODUCTDESC">
        <input type="text" :value="gmcFormData.returnUrl" name="RETURNURL" id="RETURNURL">
        <input type="text" :value="gmcFormData.backendUrl" name="BACKENDURL" id="BACKENDURL">
        <input type="text" :value="gmcFormData.amount" name="AMOUNT" id="AMOUNT">
        <input type="text" :value="gmcFormData.currency" name="CURRENCY" id="CURRENCY">
        <input type="text" :value="gmcFormData.ref1" name="REF1" id="REF1">
        <input type="text" :value="gmcFormData.ref2" name="REF2" id="REF2">
        <input type="text" :value="gmcFormData.ref3" name="REF3" id="REF3">
        <input type="text" :value="gmcFormData.ref4" name="REF4" id="REF4">
        <input type="text" :value="gmcFormData.ref5" name="REF5" id="REF5">
        <input type="text" :value="gmcFormData.successUrl" name="SuccessUrl" id="SuccessUrl">
        <input type="text" :value="gmcFormData.failUrl" name="FailUrl" id="FailUrl">
        <input type="text" :value="gmcFormData.cancelUrl" name="CancelUrl" id="CancelUrl">
    </form>   
  </v-container>
</template>

<script>
import BookingService from '../../services/booking.service'

export default {
  created(){
    this.searchId= this.$route.params.sid;
    this.paymentCode = this.$route.params.pm;
    this.merchantCode = this.$route.params.mrch;
    //alert(this.searchId + ' : ' + this.paymentCode + ' : ' + this.merchantCode);
    this.getGmcForm(this.searchId,this.paymentCode,this.merchantCode);
  },
  data(){
    return {
      searchId:null,
      paymentCode:null,
      merchantCode:null,
      gmcFormData:{
          actionUrl:"",
          merchantCode:"",
          paymentCode:"",
          productDesc:"",
          returnUrl:"",
          backendUrl:"",
          amount:"",
          currency:"",
          ref1:"",
          ref2:"",
          ref3:"",
          ref4:"",
          ref5:"",
          successUrl:"",
          failUrl:"",
          cancelUrl:"",
      },      
    }
  },
  methods:{
    submitForm(){
      this.$refs.formGmc.submit();   
      /*
        if (this.termsChecked){
            if (this.selectedCardType<0){
                this.warning1Message = "Please select card type.";
                this.showWarning1 = true;                    
                return;
            }
            this.$refs.formGmc.submit();   
        }else{
            this.warning1Message = "Please accept payment terms and conditions.";
            this.showWarning1 = true;
        }
      */
    },    
    getGmcForm(sid,paymentCode,merchantCode){
      this.warning1Message = "";
      this.showWarning1 = false;
      BookingService.getGmcForm(sid,paymentCode,merchantCode).then(rslt=>{
          let formData = rslt.data.GMCFormObj;
          //this.gmcForm = rslt.data.GMCForm;

          try {
              this.gmcFormData.actionUrl = formData.ActionUrl;  
              this.gmcFormData.amount = formData.Amount.toFixed(2);
              this.gmcFormData.backendUrl = formData.BackEndUrl;
              this.gmcFormData.cancelUrl = formData.CancelUrl;
              this.gmcFormData.currency = formData.Currency;
              this.gmcFormData.failUrl = formData.FailUrl;
              this.gmcFormData.merchantCode = formData.MerchantCode;
              this.gmcFormData.paymentCode = formData.PaymentCode;
              this.gmcFormData.ref1 = formData.Ref1;
              this.gmcFormData.ref2 = formData.Ref2;
              this.gmcFormData.ref3 = formData.Ref3;
              this.gmcFormData.ref4 = formData.Ref4;
              this.gmcFormData.ref5 = formData.Ref5;
              this.gmcFormData.returnUrl = formData.ReturnUrl;
              this.gmcFormData.successUrl = formData.SuccessUrl;
              this.gmcFormData.productDesc = "GO - " + formData.Ref2;
          } catch (error) {
              if (rslt.data.indexOf("QrCodePay")>=0){
                  this.gmcFormData.actionUrl = "https://qago2api.galileo.co.th" + rslt.data;
              }                        
          }
          
          setTimeout(() => {
              this.submitForm();  
          }, 2000);
          
      });
  },        
  }
}
</script>

<style>

</style>